import React from 'react'

export const SidebarList = ({ children }) => {
  return <ul className="menu-list">{children}</ul>
}
